import { z } from 'zod'

import { ZSearchFilter } from '@/entities/map/@x/room'
import { ZInfiniteScrollSearchParams, InfiniteScroll } from '@/shared/api'

import { RoomSortOption } from '../../model/room'
import { TRoomPreview } from '../../model/schema'

export const ZRoomsSearchParams = ZSearchFilter.merge(
  ZInfiniteScrollSearchParams,
).extend({
  keyword: z.string().optional(),
  sortBy: z.nativeEnum(RoomSortOption),
})

export type TRoomsSearchParams = z.infer<typeof ZRoomsSearchParams>

export const ZRoomsEvent = z.object({
  eventName: z.string(),
  action: z.string(),
  label: z.string(),
  value: z.number(),
})

export type TRoomsEvent = z.infer<typeof ZRoomsEvent>

export type TRoomsResponse = {
  rooms: InfiniteScroll<TRoomPreview>
  airbridgeEvent: TRoomsEvent
}
